<!-- 控销-商品管理 -->
<template>
  <div class="classification">
    <div class="header">
      <el-form ref="formTool"
               :model="formTool"
               :inline="true"
               style="text-align: left">
        <el-form-item prop="shopName"
                      label="">
          <el-input v-model="formTool.shopName"
                    placeholder="请输入商户名称"
                    clearable
                    size="small" />
        </el-form-item>
        <el-form-item>
          <el-button size="small"
                     type="primary"
                     @click="getList(1)">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button size="small"
                     @click="reset()">重置</el-button>
        </el-form-item>
      </el-form>

    </div>

    <div class="center"
         style="position: relative">
      <MyTable :table-data="tableData"
               :index="index"
               :selection="selection"
               :page="page"
               :operation="operation"
               :table-option.sync="tableOption"
               @page-change="getList"
               @handleSelectionChange="handleSelectionChange">
        <template slot="deliverControl"
                  slot-scope="scope">
          <span v-if="scope.row.deliverControl ==0 ">
            独立
          </span>
          <span v-if="scope.row.deliverControl ==1 ">
            统一
          </span>
        </template>
        <template slot="afterSalesControl"
                  slot-scope="scope">
          <span v-if="scope.row.afterSalesControl ==0 ">
            独立
          </span>
          <span v-if="scope.row.afterSalesControl ==1 ">
            统一
          </span>
        </template>
        <template slot="customerControl"
                  slot-scope="scope">
          <span v-if="scope.row.customerControl ==0 ">
            部门
          </span>
          <span v-if="scope.row.customerControl ==1 ">
            部门/公司
          </span>
        </template>

        <template slot="withdrawalControl"
                  slot-scope="scope">
          <span v-if="scope.row.withdrawalControl ==0 ">
            独立
          </span>
          <span v-if="scope.row.withdrawalControl ==1 ">
            统一
          </span>
        </template>

        <template slot="menu"
                  slot-scope="scope"
                 >
                 <span  
                 @click="detailHandle(scope.row, 'edit')"
                 style="text-align: left; color:#f5222d; cursor: pointer;"
                 class="btn-list">设置</span>
        </template>

        <el-pagination @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :page-sizes="[10, 20, 30, 50]"
                       layout="sizes, prev, pager, next"
                       :total="page.total">
        </el-pagination>

      </MyTable>
    </div>

    <dataDialog ref="setting-dailog" />
  </div>
</template>

<script>
import MyTable from "@/components/myTable";
import dataDialog from "./components/dataDialog.vue";
import { mapGetters } from 'vuex'

import { queryAuthPage } from "@/api/externalSalesRule";
import avater from "/public/img/default.png";
export default {
  components: { MyTable, dataDialog },
  data () {
    return {
      avater: avater,
      formTool: {
        name: "",
      },
      btnType: 'add',
      selectionList: [],
      operation: false,
      selection: false,
      index: true,
      tableData: [],
      tableOption: [
        { label: "商户名称", prop: "shopName" },
        { label: "发货控制", prop: "deliverControl", slot: true },
        { label: "售后控制", prop: "afterSalesControl", slot: true },
        { label: "客户控制", prop: "customerControl", slot: true },
        { label: "提现控制", prop: "withdrawalControl", slot: true },
        { label: "操作", prop: "menu", slot: true , width: '100px',align: 'left'},
      ],
      page: {
        total: 0,
        current: 1,
        size: 10,
        pageSizes: [10, 20, 30, 50],
      },

      dialogShow: false
    };
  },
  computed: {},
  watch: {},
  created () {
    this.getProductLines();
  },
  mounted () { },
  beforeCreate () { },
  beforeMount () { },
  beforeUpdate () { },
  updated () { },
  beforeDestroy () { },
  destroyed () { },
  activated () { },
  computed: {
    ...mapGetters(['permissions']),
  },
  methods: {
    didSelectItem (row) {
      // 选择商品
      this.$refs['setting-dailog'].init(row, 'add')
    },
    // 页码变化
    handleCurrentChange (e) {
      this.page.current = e
    },
    // 条数变化
    handleSizeChange (e) {
      this.page.size = e
      this.page.current = 1
    },

    detailHandle (row, btnType) {
      if (btnType == 'add') {
        this.$refs['goods-dailog'].init(row, btnType)
      } else {
        this.$refs['setting-dailog'].init(row, btnType)
      }
    },
    // 重置查询条件
    reset () {
      this.formTool = {};
      this.getList(1);
    },
    // 搜索
    getList (current) {
      this.getProductLines(current);
    },
    // 勾选
    handleSelectionChange (val) {
      this.selectionList = val;
    },
    // 查询产品线
    getProductLines (current) {
      if (current) {
        // 搜索条件改变从第一页开始查询
        this.page.current = current;
      }
      if (this.formTool.name == "") {
        delete this.formTool.name;
      }
      const params = {
        ...this.formTool,
        current: this.page.current,
        size: this.page.size,
      };
      queryAuthPage(params).then((res) => {
        this.tableData = res.records;
        this.page.total = res.total;
      });
    },
  },
};
</script>
<style lang='scss' scoped>
@import "@/styles/variables.scss";

.classification {
  padding: 0px;

  .header {
    height: 56px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 24px 0px 24px !important;
    border-bottom: 1px solid #f5f5f5;

    .font {
      font-size: 16px;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: 600;
      text-align: left;
      color: #262626;
    }

    .el-form-item {
      margin: 0px 0px 0px 8px !important;
    }
  }

  background: white;

  .top {
    display: flex;
    padding: 10px 0 10px 0;

    .item {
      display: flex;
      align-items: center;
      margin-right: 20px;

      .label {
        width: 120px;
      }

      .button {
        margin-right: 20px;

        ::v-deep .el-button {
          color: $subMenuActiveText;
          background-color: $butColor;
          border-color: $butColor;

          &:hover {
            color: $subMenuActiveText;
            background-color: $butColor;
            border-color: $butColor;
          }

          &:active {
            color: $subMenuActiveText;
            background: $butColor;
            background-color: $butColor;
            border-color: $butColor;
          }

          &:focus {
            color: $subMenuActiveText;
            background-color: $butColor;
            border-color: $butColor;
          }
        }
      }
    }
  }

  .center {
    margin-top: 16px;
    padding: 0 24px;
    height: calc(100% - 131px);

    .shangjia {
      position: absolute;
      z-index: 2;
      bottom: -45px;
    }
  }

  .btn-warp {
    display: flex;
    justify-content: space-around;
    align-items: left;
    
    .el-link {
      // margin: 5px;
    }
  }
}
</style>
